import LiveCamPaywall from './LiveCamPaywall';

export default LiveCamPaywall;
